/*
 * AAW popups — a port of the appreciationatwork.com popup behaviour
 * (wp-content/themes/appreciation-at-work/assets/js/main.js, "Popups").
 *
 *   <a data-aaw-popup="ID" href="…">       opens <dialog id="ID">
 *   <button data-aaw-popup-close>           closes it
 *   <iframe data-src="…">                    loaded on first open, not with the page
 *   .aaw-formembed[data-resize-script]       the form provider's resize script,
 *                                            loaded once, on open
 *
 * The trigger is a real link to the form, so without this file (or without
 * dialog support) the button still gets someone to the form.
 */
(function () {
  'use strict';

  var loadedScripts = {};

  function loadResizeScript(src) {
    if (!src || loadedScripts[src]) return;
    loadedScripts[src] = true;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    document.body.appendChild(s);
  }

  function open(dialog) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;

    var frames = dialog.querySelectorAll('iframe[data-src]');
    for (var i = 0; i < frames.length; i++) {
      frames[i].src = frames[i].getAttribute('data-src');
      frames[i].removeAttribute('data-src');
    }

    var embeds = dialog.querySelectorAll('.aaw-formembed[data-resize-script]');
    for (var j = 0; j < embeds.length; j++) {
      loadResizeScript(embeds[j].getAttribute('data-resize-script'));
    }

    dialog.showModal();
    return true;
  }

  // Closing: the close button, or a click outside the panel. Escape is the
  // browser's own <dialog> behaviour.
  document.addEventListener('click', function (event) {
    var dialog = event.target.closest('dialog.aaw-popup');
    if (dialog && dialog.open) {
      if (event.target.closest('[data-aaw-popup-close]') || !event.target.closest('.aaw-popup__panel')) {
        dialog.close();
      }
      return;
    }

    var trigger = event.target.closest('[data-aaw-popup]');
    if (!trigger) return;

    // A modified click does what the visitor asked: open the form in a new tab.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

    // preventDefault only once the dialog is really open, so a browser without
    // showModal() follows the link instead of doing nothing.
    if (open(document.getElementById(trigger.getAttribute('data-aaw-popup')))) {
      event.preventDefault();
    }
  });
})();
